import { Injectable } from '@angular/core';
import { ConfigurationControllerService } from '@iota/iota-management-portal-v4-client';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, take } from 'rxjs';
import { ConfigActionTypes, LoadDefaultProductPricingOptions } from '../actions/config.actions';

@Injectable()
export class ConfigEffects {
    loadDefaultProductPricingOptions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadDefaultProductPricingOptions),
            switchMap(() =>
                this.apiService.configFile('default_product_pricing_options.json').pipe(
                    take(1),
                    map((res) => ({
                        type: ConfigActionTypes.LoadDefaultProductPricingOptionsSuccess,
                        result: res
                    })),
                    catchError((error) => of({ type: ConfigActionTypes.LoadConfigFailure, error: error }))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private apiService: ConfigurationControllerService
    ) {}
}
